import { ReactNode } from 'react';

import { DecoratorNode, SerializedLexicalNode, LexicalNode } from 'lexical';

import { VariableDropdown } from './variable-dropdown';

interface SerializedVariableNode extends SerializedLexicalNode {
  variable: string;
}

export class VariableNode extends DecoratorNode<ReactNode> {
  private __variable: string;

  static override getType() {
    return 'variable';
  }

  static override clone(node: VariableNode) {
    return $createVariableNode(node.__variable, node.__key);
  }

  constructor(variable: string, key?: string) {
    super(key);
    this.__variable = variable;
  }

  override createDOM(): HTMLElement {
    const div = document.createElement('div');
    div.className = 'variable-node inline-block align-top';
    return div;
  }

  override updateDOM(prevNode: VariableNode): boolean {
    return prevNode.__variable !== this.__variable;
  }

  static override importJSON(serializedNode: SerializedVariableNode) {
    return $createVariableNode(serializedNode.variable);
  }

  override exportJSON(): SerializedLexicalNode {
    return {
      type: 'variable',
      variable: this.__variable,
      version: 1,
    } as SerializedLexicalNode;
  }

  override decorate(): ReactNode {
    return <VariableDropdown variable={this.__variable} nodeId={this.__key} />;
  }

  override getTextContent() {
    return this.getVariableValue();
  }

  getVariableValue() {
    return this.__variable;
  }

  setVariable(variable: string) {
    this.getWritable().__variable = variable;
  }
}

export function $createVariableNode(variable: string, key?: string): VariableNode {
  return new VariableNode(variable, key);
}

export function $isVariableNode(node: LexicalNode | null | undefined): node is VariableNode {
  return node instanceof VariableNode;
}
